import { STORE_SERVICES } from '../../../../../views/phone-answering/constants';

export default {
  title: 'Servizi',
  options: {
    [STORE_SERVICES.CATERING]: 'Catering',
    [STORE_SERVICES.TERRACE]: 'Terrazza disponibile',
    [STORE_SERVICES.DINE_IN]: 'Al tavolo',
    [STORE_SERVICES.ONLINE_ORDERING]: 'Ordini online tramite FoodAmigos',
    [STORE_SERVICES.RESERVATION]: 'Prenotazioni tramite FoodAmigos',
    [STORE_SERVICES.INTERNAL_RESERVATION]: 'Prenotazioni in ristorante',
  },
  labels: {
    reservation_total_seats: 'Posti totali per prenotazioni',
    catering_min_people: 'Persone min. catering',
  },
};
